import React from 'react';
import './divider.scss';
import classNames from 'classnames';

interface Props {
  className?: string;
}

const Divider = ({ className = '' }: Props) => (
  <div className={classNames('divider', className)} data-testid="common-divider"></div>
);

export default Divider;
